import { withRouterV6 } from 'helpers/connectWithRouter';
import * as React from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

const styles = require('./styles.pcss');

type Props = {
  link: string;
  icon: any;
  text: string;
  description?: string;
  navigate: NavigateFunction;
};

const Box = (props: Props) => {
  const navigate = useNavigate();

  return (
    <div
      className={styles.box}
      onClick={() => {
        navigate(props.link);
      }}
    >
      <div className={styles.boxTextContainer}>
        <div className={styles.iconStyle}>{props.icon}</div>
        <div className={styles.textStyle}>
          <div>{props.text}</div>
          {props.description && (
            <div className={styles.description}>{props.description}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouterV6(Box);
